var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-panel"},[(_vm.isStudent)?_c('RollCall'):_c('RollCallTeacher'),_c('AnswerMachine'),_c('Quiz'),_c('MediaPlayer'),_c('Lottery'),_c('AttentionDetection'),_c('SettingDialog')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }